export const adverseMediaEntityTypes = [
  { label: 'Organization', value: 'true' },
  { label: 'Person', value: 'false' }
]
